import { JSX, Show } from "solid-js";
import { StaticImagePreview } from "@/components/image-preview/StaticImagePreview";
import {
  CheckoutAlert,
  CheckoutAlertType,
} from "../checkout-alert/CheckoutAlert";
import {
  useCheckoutFlow,
  CHECKOUT_STEP_TITLES,
  CHECKOUT_STEP_DESCRIPTIONS,
} from "@/contexts/checkout-flow/checkout-flow.provider";

interface CheckoutBodyProps {
  children: JSX.Element;
  alertType?: CheckoutAlertType;
}

export const CheckoutBody = (props: CheckoutBodyProps) => {
  const { currentStep } = useCheckoutFlow();

  return (
    <fd-mfe-container class="py-FsSpacing15x px-FsSpacing1x @xs:py-FsSizing4x @xs:px-FsSizing3x shadow-FsElevationSurface01 w-full h-screen @xs:h-auto">
      <Show when={props.alertType && currentStep() !== "CANCEL"}>
        <CheckoutAlert type={props.alertType!} />
      </Show>
      <h2 class="font-FsFontFamily font-FsFontWeightSemibold text-FsFontSize0875x uppercase tracking-wider mt-0">
        {CHECKOUT_STEP_TITLES[currentStep()]}
      </h2>
      <Show when={CHECKOUT_STEP_DESCRIPTIONS[currentStep()]}>
        <p class="text-FsFontSize0875x text-FsClrNeutralGray550 mb-FsSpacing15x @xs:mb-FsSpacing25x">
          {CHECKOUT_STEP_DESCRIPTIONS[currentStep()]}
        </p>
      </Show>
      <fd-mfe-divider prop:emphasis="low" />
      <div class="flex gap-FsSizing5x mt-FsSpacing15x @xs:mt-FsSpacing3x">
        <div class="w-full">{props.children}</div>
        <div class="hidden @xs:block w-full">
          <StaticImagePreview />
        </div>
      </div>
    </fd-mfe-container>
  );
};
